module.exports = __webpack_public_path__ + "media/assets/images/blog/colored_email-7116162f23b2dd441effcefcc08df6e1.png";